const FEEDBACK_HINT_SHOWN_KEY = 'feedbackHintShown';

/**
 * Check if the feedback hint has already been shown
 */
function hasShownFeedbackHint(): boolean {
  if (typeof window === 'undefined') return true;
  return localStorage.getItem(FEEDBACK_HINT_SHOWN_KEY) === 'true';
}

/**
 * Mark the feedback hint as shown and notify other components to display it
 * - Called when user dismisses feedback toast/modal
 * - Only shows if not already shown before
 */
export function triggerFeedbackHint(): void {
  if (typeof window === 'undefined') return;

  // Only show if it hasn't been shown before
  const shouldShow = !hasShownFeedbackHint();

  if (shouldShow) {
    // Notify other components
    window.dispatchEvent(new CustomEvent('feedbackHintChanged', { detail: shouldShow }));
    localStorage.setItem(FEEDBACK_HINT_SHOWN_KEY, 'true');
  }
}
